import { AfterContentInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss']
})
export class PanelComponent implements AfterContentInit {
  @Input() form: FormGroup;
  @Input() label: string;
  @Input() labelSecondary: string;
  @Input() hidden: boolean;
  @ViewChild('panelContent') templateContent: TemplateRef<HTMLElement>;
  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterContentInit(): void {
    this.cdr.detectChanges();
  }
}
